import React, { useState } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import './App.css';
import { ProgressProvider } from './progress';
import { ChessLayout, ScrollToTop } from './components/Layout';
import Home from './pages/Home';
import Opening from './pages/Opening';
import Moves from './pages/Moves';
import Puzzles from './pages/Puzzles';
import Puzzle from './pages/Puzzle';
import Endgame from './pages/Endgame';
import Classic from './pages/Classic';
import AishuPage from './pages/Aishu';

// Links shared before the chess redesign keep working.
function LegacyScenarioRedirect() {
  const { scenarioId } = useParams();
  return <Navigate to={`/puzzles/${scenarioId}`} replace />;
}

function App() {
  const [aishuAuthenticated, setAishuAuthenticated] = useState(false);

  return (
    <ProgressProvider>
      <ScrollToTop />
      <Routes>
        <Route element={<ChessLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/opening" element={<Opening />} />
          <Route path="/moves" element={<Moves />} />
          <Route path="/puzzles" element={<Puzzles />} />
          <Route path="/puzzles/:puzzleId" element={<Puzzle />} />
          <Route path="/endgame" element={<Endgame />} />
        </Route>
        <Route path="/classic" element={<Classic />} />
        <Route path="/traditional" element={<Navigate to="/classic" replace />} />
        <Route path="/adventure" element={<Navigate to="/puzzles" replace />} />
        <Route path="/adventure/:scenarioId" element={<LegacyScenarioRedirect />} />
        <Route
          path="/aishu"
          element={<AishuPage isAuthenticated={aishuAuthenticated} onAuthenticate={setAishuAuthenticated} />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ProgressProvider>
  );
}

export default App;
